export class CustomMapConfigControl {
  constructor(isConfigOpen) {
    this.isConfigOpen = isConfigOpen
  }

  onAdd(map) {
    this._map = map
    this._container = document.createElement('div')
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group'

    // スタイル追加（重複防止）
    if (!document.querySelector('#custom-base-map-style')) {
      const style = document.createElement('style')
      style.id = 'custom-base-map-style'
      style.textContent = `
        .custom-geolocate-icon[data-type="config"] {
          background-image: url('https://gvs.weathernews.jp/onebox/radar/img/icon/icon_setting.svg');
        }
      `
      document.head.append(style)
    }

    // コントロールのHTML
    this._container.innerHTML = `
      <button type="button" id="map-config-btn">
        <span class="custom-geolocate-icon" data-type="config" aria-hidden="true"></span>
      </button>
    `

    const btn = this._container.querySelector('#map-config-btn')
    btn.addEventListener('click', () => {
      this.isConfigOpen.value = !this.isConfigOpen.value
    })

    return this._container
  }

  onRemove() {
    this._container.remove()
    this._map = undefined
  }
}
